import { FeatureConfiguration } from "..";
import { reducer } from "./reducers/updates";

export * from "./reducers";

export default function (config: FeatureConfiguration) {
    config.reducers.applicationUpdate = reducer;
}
